import React from "react";
import { useHistory, useParams } from 'react-router-dom';
import ConferenceSettings from "../ConferenceSetting";

const ConfSettings = (props) => {
    const { id } = useParams();
    const history = useHistory();

    return <ConferenceSettings role={null} id={id} uid={null} history={history} />
}
export default ConfSettings;

